import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStateService } from '@core/services/authApiService/user-state-service.service';
import { UserRoles } from '@core/consts/userRoles';

const ROLE_REDIRECT: Record<UserRoles, string> = {
  [UserRoles.PATIENT]: '/patient-portal',
  [UserRoles.CLINICIAN]: '/clinician-portal',
  [UserRoles.HEAD_OF_PRACTICE]: '/facility-portal',
  [UserRoles.SYSADMIN]: '/sysadmin-panel',
};

export const guestGuard: CanActivateFn = () => {
  const userState = inject(UserStateService);
  const router = inject(Router);

  if (!userState.isLoggedIn()) {
    return true;
  }

  const role = userState.role() as UserRoles;
  return router.createUrlTree([ROLE_REDIRECT[role] ?? '/']);
};
